import request from '../utils/request';



/*文章列表查询*/
export const theArticleListsTheQuery = (query) => {
    return request({
        url: '/dev-api/cms/cms/api/article/list',
        // data: JSON.stringify(query),
        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        params: query,
    });
};


//资讯栏目
export const informationSection = (query) => {
    return request({
        url: '/dev-api/cms/cms/api/column/list',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        params: query,
    });
};


//文章列表分页查询
export const listThePagingQuery = (query) => {
    return request({
        url: '/dev-api/cms/cms/api/article/list/page',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        params: query,
    });
};




/*资讯详情*/
export const informationForDetails = (query) => {
    return request({
        url: '/dev-api/cms/cms/api/article/' + query,
        data: JSON.stringify(query),
        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        // params: query,
    });
};

/*课程评价详情*/
export const courseDetailsFor = (query) => {
    return request({
        url: '/dev-api/index/index/project/',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        // params: query,
    });
};



/*查询省市*/
export const queryTheProvincesAndCities = (query) => {
    return request({
        url: '/dev-api/index/index/index/district',
        data: JSON.stringify(query),
        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        // params: query,
    });
};


/*注册*/
export const registered = (query) => {
    return request({
        url: '/dev-api/index/index/index/regist',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        params: query,
    });
};

/*登录后获取权限*/
export const afterTheLoginAccessPermissions = (query) => {
    return request({
        url: '/dev-api/getInfo',

        headers: {
            // 'content-type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("token") + ''
        },
        method: 'GET',
        params: query,
    });
};

/*登录后获取菜单*/
export const loginAccessToTheMenu = (query) => {
    return request({
        url: '/dev-api/getRouters',

        headers: {
            // 'content-type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("token") + ''
        },
        method: 'GET',
        params: query,
    });
};

/*我的评价*/
export const myEvaluation = (query) => {
    return request({
        url: '/dev-api/index/index/index/userAssess/' + query + '',
        headers: {
            // 'content-type': 'application/json',
            isToken: false,
            'Authorization': 'Bearer ' + localStorage.getItem("token") + ''
        },
        method: 'GET',

    });
};
/*我的实验*/
export const myTraining = (query) => {
    return request({
        url: '/dev-api/index/index/getMyLab',
        headers: {
            // 'content-type': 'application/json',
            //  isToken: false,
            // 'Authorization': 'Bearer ' + localStorage.getItem("token") + ''
        },
        method: 'GET',
        params: query,
    });
};





/*首页和列表页项目分类*/
export const projectClassification = (query) => {
    return request({
        url: '/dev-api/index/index/getProjectMajorNumList',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        params: query,
    });
};


/*实验项目列表*/
export const trainingProjectList = (query) => {
    return request({
        url: '/dev-api/index/index/getProjectList',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        params: query,
    });
};



/*注册身份获取*/
export const registrationStatusFor = (query) => {
    return request({
        url: '/dev-api/index/index/getTypeForRegist',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        params: query,
    });
};


/*首页最新排行*/
export const theLatestRanking = (query) => {
    return request({
        url: '/dev-api/index/index/getProjectListByTime',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        params: query,
    });
};

/*分类字典*/
export const classificationOfDictionary = (query) => {
    return request({
        url: '/dev-api/index/index/getSeachCondition',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        params: query,
    });
};


/*登录*/
export const theLogin = (query) => {
    return request({
        url: '/dev-api/index/index/login',
        data: JSON.stringify(query),
        headers: {

            'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        params: query,
    });
};


/*个人信息查询*/
export const personalInformationQuery = (query) => {
    return request({
        url: '/dev-api/index/index/index/profile',
        data: JSON.stringify(query),
        headers: {

            'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("token") + ''
        },
        method: 'POST',
        params: query,
    });
};


/*上传图片*/
export const toUploadPictures = (query) => {
    return request({
        url: '/dev-api/index/index/prod-api/common/upload',
        data: JSON.stringify(query),
        headers: {

            'content-type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("token") + ''
        },
        method: 'POST',
        params: query,
    });
};

/*修改密码*/
export const changeThePassword = (query) => {
    return request({
        url: '/dev-api/system/user/profile/updatePwd',
        data: JSON.stringify(query),
        headers: {

            'content-type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("token") + ''
        },
        method: 'PUT',
        params: query,
    });
};




/*忘记密码*/
export const forgotPassword = (query) => {
    return request({
        url: '/dev-api/index/index/index/forgetPwd',
        data: JSON.stringify(query),
        headers: {

            'content-type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("token") + ''
        },
        method: 'POST',
        params: query,
    });
};


/*我的收藏*/
export const myCollection = (query) => {
    return request({
        url: '/dev-api/index/index/index/favorite/list',
        data: JSON.stringify(query),
        headers: {
            // 'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("token") + '',

        },
        method: 'GET',
        params: query,


    });
};


/*删除收藏*/
export const deleteTheCollection = (query) => {
    return request({
        url: '/dev-api/index/index/index/favorite',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("token") + '',

        },
        method: 'POST',
        // params: query,


    });
};

/*修改个人信息*/
export const modifyPersonalInformation = (query) => {
    return request({
        url: '/dev-api/index/index/index/updateProfile',
        data: JSON.stringify(query),
        headers: {

            'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("token") + ''
        },
        method: 'PUT',
        params: query,
    });
};



/*注册发送短信*/
export const registeredToSendMessages = (query) => {
    return request({
        url: '/dev-api/index/index/huawei/sendSms/' + query + '',
        headers: {
            'Contenttype': 'application/x-www-form-urlencoded;charset=UTF-8'
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',

    });
};



/*获取验证码*/
export const getVerificationCode = (query) => {
    return request({
        url: ' /dev-api/captchaImage',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',

    });
};



/*首页最热排行*/
export const theHottestRanking = (query) => {
    return request({
        url: '/dev-api/index/index/getProjectListByVisited',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        params: query,
    });
};



/*查询省接口*/
export const queryInterfaceProvince = (query) => {
    return request({
        url: '/dev-api/index/index/index/province',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',

    });
};

/*课程评价列表*/
export const curriculumEvaluationList = (query) => {
    return request({
        url: '/dev-api/index/index/index/courseAssess/' + query,
        data: JSON.stringify(query),
        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',

    });
};


/*获取门户身份*/
export const accessToThePortalAs = (query) => {
    return request({
        url: '/dev-api/prod-api/system/dict/data/list?pageNum=1&pageSize=10&dictType=index_type',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',

    });
};





/*查询市接口*/
export const cityOfQueryInterface = (query) => {
    return request({
        url: '/dev-api/index/index/index/city',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        params: query,
    });
};



/*列表页实验项目*/
export const actualProjectListPage = (query) => {
    return request({
        url: '/dev-api/index/index/getTrainProjectList',

        headers: {
            // 'content-type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        params: query,
    });
};




/*课程评价新增*/
export const evaluationOfNew = (query) => {
    return request({
        url: '/dev-api/index/index/index/addAssess',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        // params: query,
    });
};




/*共享应用*/
export const theSharedApplication = (query) => {
    return request({
        url: '/dev-api/index/index/getshareProject/' + query + '',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        // params: query,
    });
};



/*收藏*/
export const collection = (query) => {
    return request({
        url: '/dev-api/index/index/index/favorite/add',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        params: query,
    });
};



/*点赞*/
export const giveALike = (query) => {
    return request({
        url: '/dev-api/index/index/thumb/add',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        params: query,
    });
};


/*实验评分*/
export const testScore = (query) => {
    return request({
        url: '/dev-api/index/index/index/courseScoreAvg/' + query + '',
        // data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        //  params: query,
    });
};

/*我要做实验*/
export const iWantToBePractical = (query) => {
    return request({
        url: '/dev-api/index/index/doLab',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        params: query,
    });
};


/*人气指数*/
export const theSentimentIndex = (query) => {
    return request({
        url: '/dev-api/index/index/orderByJoinStd',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        //params: query,
    });
};


/*共享数据*/
export const sharedData = (query) => {
    return request({
        url: '/dev-api/index/index/orderByShareStd',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        //params: query,
    });
};


/*互动数据*/
export const interactiveData = (query) => {
    return request({
        url: '/dev-api/index/index/orderByInteractStd',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        //params: query,
    });
};



/*吸引数据*/
export const attractData = (query) => {
    return request({
        url: '/dev-api/index/index/orderByAttractStd',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        //params: query,
    });
};



/*退出选课接口*/
export const quitTheCourseSelectionInterface = (query) => {
    return request({
        url: '/dev-api/index/index/cancelDoLab',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        //params: query,
    });
};



/*我的成绩接口*/
export const myGradesInterface = (query) => {
    return request({
        url: '/dev-api/index/index/getMyLabScore',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        //params: query,
    });
};



/*成绩详情*/
export const recordDetails = (query) => {
    return request({
        url: '/dev-api/index/index/getMyLabScoreInfo',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        //params: query,
    });
};




/*下载报告*/
export const downloadTheReport = (query) => {
    return request({
        url: '/dev-api/index/index/getMyLabScoreAttach',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'POST',
        //params: query,
    });
};


/*我的实验-行为记录*/
export const recordTheData = (query) => {
    return request({
        url: '/dev-api/index/index/getMyLabStatement',
        data: JSON.stringify(query),
        headers: {
            // 'content-type': 'application/json',
            //'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },
        method: 'GET',
        params: query,
    });
};



/*我要实验*/
export const iWantToPracticer = (query) => {
    return request({
        url: '/open/open/v1/ticket?uid=' + query + '',
        data: JSON.stringify(query),
        headers: {
            'mode': 'cors',
            'content-type': 'application/json',

            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },

        method: 'GET',

        // params: query,
    });
};


/*交专接口*/


/*专业群*/
export const professionalGroupOf = (query) => {
    return request({
        url: '/index/index/vr/zzlist',
        data: JSON.stringify(query),
        headers: {
            // 'mode': 'cors',
            'content-type': 'application/json',

            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },

        method: 'GET',

        // params: query,
    });
};




/*专业群实验*/
export const groupOfProfessionalTraining = (query) => {
    return request({
        url: '/index/index/vr/djelist',
        data: JSON.stringify(query),
        headers: {
            // 'mode': 'cors',
            'content-type': 'application/json',

            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },

        method: 'GET',

        params: query,
    });
};

/*首页实验*/
export const theHomepageExperiment = (query) => {
    return request({
        url: '/index/index/vr/vrInfo',
        data: JSON.stringify(query),
        headers: {
            // 'mode': 'cors',
            'content-type': 'application/json',

            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },

        method: 'GET',

         params: query,
    });
};


/*点击进行实验*/
export const clickOnTheExperiment = (query) => {
    return request({
        url: '/index/index/vr/' + query + '',
        data: JSON.stringify(query),
        headers: {
            // 'mode': 'cors',
            'content-type': 'application/json',

            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },

        method: 'GET',

        // params: query,
    });
};



/*首页导航*/
export const homePageNavigation = (query) => {
    return request({
        url: '/index/index/vr/hList',
        data: JSON.stringify(query),
        headers: {
            // 'mode': 'cors',
            'content-type': 'application/json',

            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },

        method: 'GET',

        params: query,
    });
};


/*通知公告*/
export const announcements = (query) => {
    return request({
        url: '/cms/cms/api/article/list',
        data: JSON.stringify(query),
        headers: {
            // 'mode': 'cors',
            'content-type': 'application/json',

            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },

        method: 'GET',

        params: query,
    });
};


/*获取语音服务地址*/
export const getVoiceServerUrl = (query) => {
    return request({
        url: 'http://121.36.9.220:8800/prod-api/core/api/voiceServerUrl',
        data: JSON.stringify(query),
        headers: {
            'content-type': 'application/json',
            isToken: false,
        },
        method: 'GET',
        params: query,
    });
};




/*通知详情*/
export const informTheDetails = (query) => {
    return request({
        url: '/cms/cms/api/article/'+query+'',
        data: JSON.stringify(query),
        headers: {
            // 'mode': 'cors',
            'content-type': 'application/json',

            // 'Authorization': 'Bearer ' + localStorage.getItem("accessToken") + ''
        },

        method: 'GET',

        params: query,
    });
};













